const apiUrl = process.env.REACT_APP_API_URL;
export const GetBbddUsersIdPractiquesId = async (prac : string, id_usuari : string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/bbdd/users/${id_usuari}/practiques/${prac}`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
